/**
 * 主题工具函数
 */

// 判断是否已登录（login=1 代表登录）
function isLogin() {
  return localStorage.getItem('login') === '1'
}

// 获取当前主题
export function getTheme() {
  // 未登录直接返回默认light，不读取存储的主题
  if (!isLogin()) return 'light'
  return localStorage.getItem('sys_theme') || 'light'
}

// 设置主题并应用
export function setTheme(theme) {
  // 未登录不执行主题设置逻辑
  if (!isLogin()) return

  const htmlDom = document.documentElement
  // 移除旧主题类名
  htmlDom.classList.remove('theme-light', 'theme-dark')
  // 添加新主题类名
  htmlDom.classList.add(`theme-${theme}`)
  // 保存到本地存储
  localStorage.setItem('sys_theme', theme)
}

// 初始化主题（页面加载时调用）
export function initTheme() {
  const htmlDom = document.documentElement
  if (!isLogin()) {
    // 未登录：清空自定义主题，强制浅色，不读取用户保存的主题
    htmlDom.classList.remove('theme-light', 'theme-dark')
    htmlDom.classList.add('theme-light')
    return
  }
  // 已登录：读取并应用保存的主题
  const currentTheme = getTheme()
  setTheme(currentTheme)
}


// WEBPACK FOOTER //
// ./src/utils/theme.js